import { render } from "./AddFactoryComponent.vue?vue&type=template&id=3fcb7369"
import script from "./AddFactoryComponent.vue?vue&type=script&lang=js"
export * from "./AddFactoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__